import axios from "axios";
import api from "../server/api";

const ELEVATE_ACCOUNT_SUCCESS = "TYP/ELEVATE_ACCOUNT_SUCCESS";
const ELEVATE_ACCOUNT_REQUEST = "TYP/ELEVATE_ACCOUNT_REQUEST";
const ELEVATE_ACCOUNT_FAILURE = "TYP/ELEVATE_ACCOUNT_FAILURE";

const REQUEST_OTP_SUCCESS = "TYP/REQUEST_OTP_SUCCESS";
const REQUEST_OTP_REQUEST = "TYP/REQUEST_OTP_REQUEST";
const REQUEST_OTP_FAILURE = "TYP/REQUEST_OTP_FAILURE";

const initialState = {
  loading: false,
  error: false,
  data: [],
  success: false,
};

export default function reducerSubscriptions(state = initialState, action) {
  switch (action.type) {
    case ELEVATE_ACCOUNT_REQUEST:
      return { ...state, loading: true, error: false };
    case ELEVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ELEVATE_ACCOUNT_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    // case LOGOUT_ACCOUNT:
    //   return { ...initialState };
    case REQUEST_OTP_REQUEST:
      return { ...state, loading: true, error: false };
    case REQUEST_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case REQUEST_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    // case LOGOUT_ACCOUNT:
    //   return { ...initialState };

    default:
      return state;
  }
}

export const elevatePrivileges = (credentials) => {
  return async (dispatch) => {
    dispatch({
      type: ELEVATE_ACCOUNT_REQUEST,
    });

    try {
      const { url, method, headers, data } = api.elevatePrivileges(credentials);
      const account = await axios({
        url,
        method,
        headers,
        data,
      });
      if (account) {
        dispatch({
          type: ELEVATE_ACCOUNT_SUCCESS,
          payload: "success",
        });
      } else {
        dispatch({
          type: ELEVATE_ACCOUNT_FAILURE,
          payload: "no_account_found",
        });
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message === "account_not_approved"
      ) {
        dispatch({
          type: ELEVATE_ACCOUNT_FAILURE,
          payload: "account_not_approved",
        });
      } else {
        dispatch({
          type: ELEVATE_ACCOUNT_FAILURE,
          payload: "error_login",
        });
      }
    }
  };
};

export const requestShipmentOtp = (credentials) => {
  return async (dispatch) => {
    dispatch({
      type: REQUEST_OTP_REQUEST,
    });

    try {
      const { url, method, headers, data } =
        api.requestShipmentOtp(credentials);
      const request = await axios({
        url,
        method,
        headers,
        data,
      });
      if (request) {
        dispatch({
          type: REQUEST_OTP_SUCCESS,
          payload: "success",
        });
        return "success";
      } else {
        dispatch({
          type: REQUEST_OTP_FAILURE,
          payload: "no_account_found",
        });
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.status === 400
      ) {
        dispatch({
          type: ELEVATE_ACCOUNT_FAILURE,
          payload: "wrong mail or mobile number",
        });
      } else {
        dispatch({
          type: ELEVATE_ACCOUNT_FAILURE,
          payload: "error_request_otp",
        });
      }
    }
  };
};

export const logout = () => {
  // return async (dispatch) => {
  //   dispatch({
  //     type: LOGOUT_ACCOUNT,
  //   })
  localStorage.clear();
};
